"use strict";

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var a = 0; a < r.length; a++) {
    var n = r[a];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, r, a) {
  return r && _defineProperties(e.prototype, r), a && _defineProperties(e, a), e;
}
var Tracker = function () {
  return _createClass(function e() {
    _classCallCheck(this, e);
  }, [{
    key: "calculateTracker",
    value: function (e) {
      var r = e.totalPages,
        a = e.currentPage;
      return parseInt("".concat(a / r * 100));
    }
  }]);
}();
module.exports = {
  Tracker: Tracker
};